/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  CodeConfigurationField,
  LandingPageDestination
} from '@dtx-company/inter-app/src/types/flowcode'
import { FcShape } from '@dtx-company/flowcode-generator-browser'
import { LOGGED_OUT_GENERATOR_COLORS } from '../../components/Homepage/SimplifiedDesktop/constants'
import { LocgContext, LocgEvent, ScrollTargetEvent, ValidationErrorData } from './locgMachine.types'
import { LoggedOutGeneratorSection } from '../../components/LoggedOutCodeGeneratorV2/LoggedOutCodeGenerator.types'
import {
  RIM_TEXT_CIRCLE_MAX_LENGTH,
  RIM_TEXT_SQUARE_MAX_LENGTH
} from '../../components/LoggedOutCodeGeneratorV2/GeneratorSections/CodeDesign/FrameAndText/constants'
import { SCROLL_CONTAINER_ID } from '../../components/LoggedOutCodeGeneratorV2/LoggedOutCodeGenerator.constants'
import { assign, createMachine, forwardTo } from 'xstate'
import { authFormMachine } from './authForm/authFormMachine'
import { scrollWithinContainer } from '@dtx-company/true-common/src/utils/scrolling/scrollWithinContainer'
import { tempAssetMachine } from './tempAsset/tempAssetMachine'
import { validateScanDestination } from './services/validateScanDestination'

export const createLocgMachine = (
  {
    initialState
  }: { initialState?: 'scanDestination' | 'codeDesign' | 'auth' | 'autogeneratedOptions' } = {
    initialState: 'scanDestination'
  }
) => {
  return createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QBkDyBhA4gOlgYwEMA7AETgBcBLIgqgeyIGIA5AUQA0AVAbQAYBdRKAAOdWJXpEhIAB6IAtAEYArAA5si1QDYAnNtV7FAdmUAmLQBoQAT0SKAzKez2jvezoAsH098VbTpgC+gVZoWLiEpBTUtJQMjCSoAOrMaACCJAD66KgkrHyCSCCi4pLScgjyWrxa2Kb2BqbKWrrGAVa2CMou2Hramkb2KqYmwaEYOPjEZLBUNJLYkBLUUIzoABJpzJj5AtIlywzlCkaKHti8p15Guqq8Hso6HQoevNiu9d71vKrKRvVjEBhSaRGZzWIMRYQZZEVZsLgFfZiQ5SIoVeRqWrKDzaXgqM72LSOZ4IYyKZyKPw-Uy-V5aRSA4HYPB0CBgGaUKBMABCaXQAGlEUUDmU0Qo7s5eLwRlpVB4WjodH4SfYLjopco2vV1VpsUZGRNmaz2XBOUxEil0lkcnkhSJkaLQBVtdhfpSGu4WooRqoSapFG96oMaf4tA8dPYDeEWWyOVyoTDVhstjs7cUHXFUU7EFpXO9sZc-CNeDplCTFDpaqojP6PC4zLqgiEgYaYybxPGlnNVgBlVicTIABQASqhMMPWD2e2mRZnjghdeT3PLdRHlMofvYSaYdK6AtoTL8fqpflGcG240QE92EslUqgMtlcrtCvbSnOxQv167jNW680dFcX0bEQeU3ncMw5Tcew8XsDwzyNWNTU7aFuyNAAbOgACc1k2bYXyRd8jk-OtyUaRwg00P5gM6eR-jqIYdB9V4XCMHEEIvZCry7FYMOwlgOB4PZhQzYjswQcx1CMExThMTVKXMctKUlAwzmPJi5WUDjjUva9eNgAALAhhDAXCUwIkSiKzWRQKGV0mIolwqJrcsS2cCMoO0L1fibcZox0ri9NhXAjJMgSEWEt8UXnST3hk-wPG9QYiUsECJIjbA-g8Jibl1U5ung5smU4jtuNQ3iADMsIIABbMA0iICBODAGRyDM-CZ1E6yKlI+z6gCJzfhctKaScJUfAaUw8WkkttKQ0qgqgbAqtq+rGua1rwqE190ysmLZTiv4EqSwlCRJDxBldOUzlcexHi+Ob2zNRbsEwqA6Ha1NIt26KSLs8iBtOIaaNA046iYrwiz+GpVEjIrDQIABXcgDMYCAGDAbBqAANzoABrTG0mRgyAFkCDwAzqDATq9s-JQwwuex3BcHE3Ac1z5XeBxmkGJVeA3Qq-JwdGAHciEwghoVhW9LQfPISBp37xKUbFXWxCs9BrHcKxB0l6mUXpHhub1dH5hl4f8+bnp46W+wHPt0E4ABJVBmEVx0bIXQDsGy6SfCm3R1w8FVXky3nNTlO4mflYJmyIY14CKYFCKVz35H9N5C2uW57keEl5FY7B6SGGsflzekIwQqYolmGIPdnMS05uJws4unPw3zqaDZPPQmlXf4tCr0FonmTNFpTj30W6dQXFzUbjzYrcRt3aT1RLNi63cG4h+mEeISvFkauEdCwHIMAJ4-ZXuiMV1dTcRs-Z+bd6VdPFNBLdcGnuQeLfPALSovo3CoZwnDq0JJcVw9I2KmE7uqTKFYvDdEJGYU6j1dI2ygIA7qdg4FgOqDNKB3h84qF3I4ZoQ1PBNCZj-IWiEnooUTHxLCWCYoNEyolcBBDjBELSm8f0fwVBeXpENTUaDAoYJCsZc+llU7OjYXgiBNRuEwLSpoJwQwBGYm8mYMRC0JErTqg1JqLVyAsM-PUdQCiuHQJVESH8mihFUV0dbcqwU3p0DMeJCx7CHD4Mgcokk2IDYaPyo47Qzj4yH2PqfaRUVJ45jYu8A8N1NSynXCSMMtQYJrz7p4SkNCWzhCRijTxacAjkm6J4B4Up-ZGFLH6Gsr8cR6Aukdbev9sCi3FnQSWKxSnok0FJFweIgyqB3FNYOqjvTkh3ExNQcFSzG20kfE+Z9+kKBUG8BB9xCSjSYoocsMF1DaFLCWFQDQ2KqFjoEIAA */
      tsTypes: {} as import('./locgMachine.typegen').Typegen0,
      schema: {
        context: {} as LocgContext,
        events: {} as LocgEvent,
        services: {} as {
          scanDestinationValidator: {
            data: Omit<ScrollTargetEvent, 'type'> | ValidationErrorData
          }
        }
      },
      predictableActionArguments: true,
      preserveActionOrder: true,
      context: {
        locale: 'en-US',
        designFirst: initialState === 'codeDesign',
        progress: 0 / 12,
        values: {
          [CodeConfigurationField.SCAN_DESTINATION_TYPE]: LandingPageDestination.URL,
          [CodeConfigurationField.SCAN_DESTINATION]: '',
          [CodeConfigurationField.REGION_CODE]: 'US',
          [CodeConfigurationField.SUBJECT]: '',
          [CodeConfigurationField.BODY]: '',
          [CodeConfigurationField.FILE]: undefined,
          [CodeConfigurationField.LOGO]: undefined,
          [CodeConfigurationField.COLOR]: LOGGED_OUT_GENERATOR_COLORS[0],
          [CodeConfigurationField.SHAPE]: FcShape.CIRCLE,
          [CodeConfigurationField.FRAME]: false,
          [CodeConfigurationField.TOP_RIM_TEXT]: '',
          [CodeConfigurationField.BOTTOM_RIM_TEXT]: '',
          [CodeConfigurationField.AUTOGENERATED_OPTIONS]: undefined
        },
        errors: {}
      },
      id: 'LOCG',
      initial: initialState,
      on: {
        SET_LOCALE: {
          actions: assign({
            locale: (_, event) => event.locale
          })
        },
        SET_DESIGN_FIRST: {
          actions: assign({
            designFirst: (_, event) => event.payload.designFirst
          })
        },
        CHANGE: {
          actions: ['onChange']
        },
        [LoggedOutGeneratorSection.ScanDestination]: {
          target: '#LOCG.scanDestination'
        },
        [LoggedOutGeneratorSection.CodeDesign]: {
          target: '#LOCG.codeDesign'
        },
        [LoggedOutGeneratorSection.SignUp]: {
          target: '#LOCG.auth'
        }
      },
      states: {
        scanDestination: {
          description: 'Select your scan destination',
          initial: 'editing',
          entry: [
            assign(context => ({
              ...context,
              progress: 4 / 12
            }))
          ],
          states: {
            editing: {
              on: {
                CHANGE: {
                  actions: ['onChange']
                },
                BLUR: {
                  target: 'validatingOnBlur'
                },
                SET_ERROR: {
                  actions: ['setError']
                },
                NEXT: {
                  target: 'validating'
                },
                DOWNLOAD_CODE: {
                  target: 'validatingAuth'
                },
                UPLOAD_TEMP_ASSET: {
                  actions: forwardTo('scan-destination-temp-asset-machine')
                },
                DELETE_TEMP_ASSET: {
                  actions: forwardTo('scan-destination-temp-asset-machine')
                }
              },
              invoke: {
                id: 'scan-destination-temp-asset-machine',
                src: tempAssetMachine
              }
            },

            validating: {
              invoke: {
                id: 'scan-destination-validator',
                src: 'scanDestinationValidator',
                onDone: {
                  target: '#LOCG.codeDesign',
                  actions: 'scrollTo'
                },
                onError: {
                  target: 'editing',
                  actions: assign({ errors: (_, event) => event.data })
                }
              }
            },

            validatingOnBlur: {
              invoke: {
                id: 'scan-destination-validator',
                src: 'scanDestinationValidator',
                onDone: {
                  target: 'editing',
                  actions: assign({ errors: (_, event) => event.data })
                },
                onError: {
                  target: 'editing',
                  actions: assign({ errors: (_, event) => event.data })
                }
              }
            },

            validatingAuth: {
              invoke: {
                id: 'auth-validator',
                src: 'scanDestinationValidator',
                onDone: {
                  target: '#LOCG.auth',
                  actions: 'scrollTo'
                },
                onError: {
                  target: 'editing',
                  actions: assign({ errors: (_, event) => event.data })
                }
              }
            }
          }
        },

        codeDesign: {
          description: 'Design your code',
          initial: 'editing',
          states: {
            editing: {
              on: {
                CHANGE: {
                  actions: ['onChange']
                },
                SET_PROGRESS: {
                  actions: ['setProgress']
                },
                DOWNLOAD_CODE: {
                  target: '#LOCG.auth'
                }
              },
              initial: 'color',
              states: {
                color: {
                  entry: [
                    assign(context => ({
                      ...context,
                      progress: 5 / 12
                    }))
                  ],
                  on: {
                    CHANGE: {
                      actions: ['onChange']
                    },
                    NEXT: 'shape'
                  }
                },
                shape: {
                  entry: [
                    assign(context => ({
                      ...context,
                      progress: 6 / 12
                    }))
                  ],
                  on: {
                    CHANGE: {
                      actions: ['onChange']
                    },
                    NEXT: 'frameAndText'
                  }
                },
                frameAndText: {
                  entry: [
                    assign(context => ({
                      ...context,
                      progress: 7 / 12
                    }))
                  ],
                  on: {
                    CHANGE: {
                      actions: ['onChange']
                    },
                    NEXT: 'logo'
                  }
                },
                logo: {
                  entry: [
                    assign(context => ({
                      ...context,
                      progress: 8 / 12
                    }))
                  ],
                  on: {
                    CHANGE: {
                      actions: ['onChange']
                    },
                    UPLOAD_TEMP_ASSET: {
                      actions: forwardTo('logo-temp-asset-machine')
                    },
                    DELETE_TEMP_ASSET: {
                      actions: forwardTo('logo-temp-asset-machine')
                    }
                  },
                  invoke: {
                    id: 'logo-temp-asset-machine',
                    src: tempAssetMachine
                  }
                }
              }
            },

            complete: {
              type: 'final'
            }
          },
          on: {
            BACK: {
              target: 'scanDestination'
            },
            DOWNLOAD_CODE: {
              target: 'auth'
            },
            [LoggedOutGeneratorSection.ColorSelector]: {
              target: '#LOCG.codeDesign.editing.color',
              actions: ['scrollTo']
            },
            [LoggedOutGeneratorSection.ShapeSelector]: {
              target: '#LOCG.codeDesign.editing.shape',
              actions: ['scrollTo']
            },
            [LoggedOutGeneratorSection.FrameAndText]: {
              target: '#LOCG.codeDesign.editing.frameAndText',
              actions: ['scrollTo']
            },
            [LoggedOutGeneratorSection.Logo]: {
              target: '#LOCG.codeDesign.editing.logo',
              actions: ['scrollTo']
            },
            [LoggedOutGeneratorSection.SignUp]: {
              target: '#LOCG.auth',
              actions: ['scrollTo']
            }
          },
          onDone: {
            target: 'auth'
          }
        },

        auth: {
          description: 'Sign up or sign in to download code',
          entry: [
            assign(context => ({
              ...context,
              progress: 12 / 12
            }))
          ],
          invoke: {
            id: 'AuthMachine',
            src: authFormMachine,
            onDone: 'downloading'
          },
          on: {
            BACK: {
              target: 'codeDesign',
              actions: ['scrollTo']
            }
          },
          onDone: 'downloading'
        },

        downloading: {
          description: 'Download your code',
          on: {
            DOWNLOADED: 'complete'
          }
        },

        complete: {
          type: 'final'
        }
      }
    },

    {
      actions: {
        setProgress: assign((context, event) => ({
          ...context,
          progress: event.progress
        })),
        /**
         * Basic assign action to update context when a field value changes
         */
        onChange: assign((context, event) => {
          const newContext = {
            ...context,
            values: {
              ...context.values,
              [event.key]: event.value
            },
            errors: {
              ...context.errors,
              [event.key]: undefined
            }
          }

          // Reduce top rim text length when user switches shape
          if (event.key === CodeConfigurationField.SHAPE) {
            if (newContext.values[CodeConfigurationField.TOP_RIM_TEXT]) {
              const maxLength =
                newContext.values.shape === FcShape.CIRCLE
                  ? RIM_TEXT_CIRCLE_MAX_LENGTH
                  : RIM_TEXT_SQUARE_MAX_LENGTH
              newContext.values[CodeConfigurationField.TOP_RIM_TEXT] = newContext.values[
                CodeConfigurationField.TOP_RIM_TEXT
              ].substring(0, maxLength)
            }
            if (newContext.values[CodeConfigurationField.BOTTOM_RIM_TEXT]) {
              const maxLength =
                newContext.values.shape === FcShape.CIRCLE
                  ? RIM_TEXT_CIRCLE_MAX_LENGTH
                  : RIM_TEXT_SQUARE_MAX_LENGTH
              newContext.values[CodeConfigurationField.BOTTOM_RIM_TEXT] = newContext.values[
                CodeConfigurationField.BOTTOM_RIM_TEXT
              ].substring(0, maxLength)
            }
          }

          if (event.key === CodeConfigurationField.SCAN_DESTINATION_TYPE) {
            /**
             * Reset scan destination, subject, and body when scan destination type changes
             */
            newContext.values[CodeConfigurationField.SCAN_DESTINATION] = ''
            newContext.values[CodeConfigurationField.SUBJECT] = ''
            newContext.values[CodeConfigurationField.BODY] = ''
            newContext.values[CodeConfigurationField.FILE] = undefined

            /**
             * Reset errors for scan destination, subject, body, and file
             * when scan destination type changes
             */
            newContext.errors[CodeConfigurationField.SCAN_DESTINATION] = undefined
            newContext.errors[CodeConfigurationField.SUBJECT] = undefined
            newContext.errors[CodeConfigurationField.BODY] = undefined
            newContext.errors[CodeConfigurationField.FILE] = undefined
          }

          return newContext
        }),
        setError: assign((context, event) => ({
          ...context,
          errors: {
            ...context.errors,
            [event.key]: event.value
          }
        })),

        scrollTo: (_, event) => {
          let target: string | undefined
          if ('target' in event && typeof event.target === 'string') {
            target = event.target
          } else if (
            'data' in event &&
            'target' in event.data &&
            typeof event.data?.target === 'string'
          ) {
            target = event.data.target
          }

          if (target) {
            // Scroll to target element after current event loop
            setTimeout(() => {
              scrollWithinContainer({
                containerId: SCROLL_CONTAINER_ID,
                elementId: target as string
              })
            }, 0)
          }
        }
      },
      services: {
        scanDestinationValidator: validateScanDestination
      },
      guards: {},
      delays: {}
    }
  )
}
